// Costanti condivise dei componenti Gantt.
export const STATO_LABELS_GANTT = {
  programmata: "Programmata",
  in_corso: "In corso",
  eseguita: "Eseguita",
  consegnato: "Consegnato",
  attesa_materiale: "Attesa materiale",
  sospesa: "Sospesa",
  in_ritardo: "In ritardo",
  da_iniziare: "Programmata",
  completata: "Eseguita",
};

// Lavorazioni standard cantiere edile — usate dal seed rapido.
// L'ordine corrisponde alla sequenza tipica di cantiere.
export const LAVORAZIONI_STANDARD = [
  { nome: "Approntamento",           categoria: "Preparazione" },
  { nome: "Demolizioni",             categoria: "Demolizioni" },
  { nome: "Costruzioni",             categoria: "Opere edili" },
  { nome: "Impianto elettrico",      categoria: "Impianti" },
  { nome: "Impianto idraulico",      categoria: "Impianti" },
  { nome: "Impianto condizionamento",categoria: "Impianti" },
  { nome: "Tinteggiature",           categoria: "Finiture" },
];

export function GanttInput({ label, value, onChange, type = "text", testid }) {
  return (
    <div>
      <label className="text-xs font-semibold text-slate-600 block mb-1">{label}</label>
      <input
        type={type}
        data-testid={testid}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-slate-300 rounded-sm text-sm"
      />
    </div>
  );
}
